// 方案管理
import http from "@/jslibs/axios/http";

// 方案列表
export const list = (data) => http.get("/v1/cms/Mscheme", data);

// 方案新增
export const add = (data) => http.post("/v1/cms/Mscheme", data);

// 方案编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/Mscheme/${uuid}`, data);

// 方案删除
export const del = (data) => http.delete(`/v1/cms/Mscheme/${data.cuuid}`);

// 方案详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/Mscheme/${cuuid}`, data);
